"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var lodash_1 = __importDefault(require("lodash"));
var auth = __importStar(require("../helpers/auth"));
function errors() {
    axios_1.default.interceptors.response.use(undefined, function (error) {
        if (error.response.status === 401) {
            auth.removeToken();
            auth.removeIsFavoriteUser();
            // Exclude certain requests
            if (!lodash_1.default.includes(['/api/login', '/api/wishlists'], error.response.config.url)) {
                window.location.reload();
            }
        }
        if (error.response.status === 413) {
            return Promise.reject({
                response: {
                    data: {
                        errors: [['EXCEED_ALLOWED_FILE_UPLOAD_SIZE']],
                    },
                },
            });
        }
        return Promise.reject(error);
    });
}
exports.default = errors;
